// extracted by mini-css-extract-plugin
export default {"courses":"topicsGrid_courses__YRFtj"};